<template>
  <div class="container detail">
    <BannerSearch> </BannerSearch>
    <div class="bg">
      <div class="innerbox" v-if="ticket != ''">
        <div class="side-tab">
          <div class="tap-box">
            <ul class="tap-ul">
              <li class="tap-li" v-for="(li, index) in this.ticket" :key="index">
                <span class="first"> {{ li.field_name.field_label == '客服编号' ? $i18n.locale == 'zh' ? '客服编号' : 'Customer
                                  Service ID' : li.field_name.field_label}} </span>
                <span class="second">{{
                  li.field_name.content_type == "chained_droplist" ?
                  checkSelect(li.field_name, li.field_detail)
                  : li.field_name.content_type == 'data_time' ? formatTime(li.field_detail) :
                    li.field_detail
                }}</span>

              </li>
            </ul>
          </div>
        </div>
        <div class="ticket-box">
          <div>
            <div class="ticket-innerbox">
              <div class="title-box">

                <div class="title">{{ title }}</div>
              </div>
              <div class="container">
                <p class="p1">{{ this.detail }}</p>
                <div class="update" v-for="(img, index) in atts" :key="index" @click="downloadImg(img.url)">

                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px"
                    height="21px">
                    <path fill-rule="evenodd" stroke="rgb(137, 137, 137)" stroke-width="2px" stroke-linecap="round"
                      stroke-linejoin="miter" fill="none"
                      d="M9.645,7.988 C9.056,8.608 5.398,12.385 4.772,13.044 C4.319,13.520 4.348,14.359 4.796,14.830 C5.244,15.301 6.034,15.325 6.487,14.849 C6.864,14.452 14.363,6.557 14.245,6.682 C15.142,5.737 15.091,4.078 14.195,3.136 C13.300,2.194 11.712,2.126 10.815,3.071 C9.572,4.379 4.246,9.987 3.077,11.217 C1.890,12.467 1.645,15.156 3.070,16.655 C4.495,18.155 6.808,18.152 8.236,16.649 C9.665,15.145 16.099,8.446 16.099,8.446 " />
                  </svg>
                  {{ img.file_name }}


                </div>

              </div>
            </div>
            <div class="ticket-innerbox" v-for="(rep, index) in  this.replies " :key="index">
              <div class="title-box">
                <div class="user" :class="{ active: rep.reply_user_type == 'agent' }">
                  <img v-if="rep.reply_user_type != 'agent'" :src="$store.state.avatarUrl" alt="">
                  <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="21px"
                    height="22px">
                    <defs>
                      <filter id="Filter_0">
                        <feFlood flood-color="rgb(248, 126, 53)" flood-opacity="1" result="floodOut" />
                        <feComposite operator="atop" in="floodOut" in2="SourceGraphic" result="compOut" />
                        <feBlend mode="normal" in="compOut" in2="SourceGraphic" />
                      </filter>

                    </defs>
                    <g filter="url(#Filter_0)">
                      <path fill-rule="evenodd" fill="rgb(229, 125, 48)"
                        d="M11.935,21.90 C12.989,20.888 14.367,20.580 15.918,19.759 C17.563,18.888 18.975,17.314 19.268,16.878 C19.808,16.76 20.97,15.823 20.177,15.360 C20.220,15.116 20.135,14.871 19.961,14.591 C19.652,14.95 19.203,13.574 19.87,13.126 C18.999,12.785 19.163,11.975 19.521,11.135 C20.63,9.863 20.204,8.35 20.169,6.979 C20.149,6.361 19.754,0.942 17.206,0.585 C14.591,0.219 12.913,4.478 12.722,5.111 C12.530,5.743 11.890,5.514 11.890,5.514 C10.864,5.153 9.527,5.153 8.501,5.514 C8.501,5.514 7.861,5.743 7.669,5.111 C7.478,4.478 5.800,0.219 3.185,0.585 C0.637,0.942 0.242,6.361 0.222,6.979 C0.187,8.35 0.328,9.863 0.870,11.135 C1.228,11.975 1.393,12.785 1.304,13.126 C1.188,13.574 0.739,14.95 0.430,14.591 C0.256,14.871 0.171,15.116 0.214,15.360 C0.294,15.823 0.584,16.76 1.123,16.878 C1.416,17.314 2.828,18.888 4.473,19.759 C6.24,20.580 7.407,20.928 8.456,21.90 C9.340,21.226 11.49,21.261 11.935,21.90 Z" />
                    </g>
                  </svg>
                  {{
                    rep.reply_user_type == "agent" ? $t("m.ticketdetail.office") : $store.state.userName ?
                    $store.state.userName :
                    rep.nick_name
                  }}
                </div>

                <div class="date">{{ convertedTime(rep.created_at) }}</div>
              </div>
              <div class="container">
                <p v-html="rep.content"></p>
                <div class="update-area">
                  <a class="update" v-for="( img, index ) in  rep.attachments " :key="index"
                    @click="downloadImg(img.url)">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px"
                      height="21px">
                      <path fill-rule="evenodd" stroke="rgb(137, 137, 137)" stroke-width="2px" stroke-linecap="round"
                        stroke-linejoin="miter" fill="none"
                        d="M9.645,7.988 C9.056,8.608 5.398,12.385 4.772,13.044 C4.319,13.520 4.348,14.359 4.796,14.830 C5.244,15.301 6.034,15.325 6.487,14.849 C6.864,14.452 14.363,6.557 14.245,6.682 C15.142,5.737 15.091,4.078 14.195,3.136 C13.300,2.194 11.712,2.126 10.815,3.071 C9.572,4.379 4.246,9.987 3.077,11.217 C1.890,12.467 1.645,15.156 3.070,16.655 C4.495,18.155 6.808,18.152 8.236,16.649 C9.665,15.145 16.099,8.446 16.099,8.446 " />
                    </svg>
                    {{ img.file_name }}
                  </a>
                </div>
              </div>
            </div>
            <!-- <a v-if="this.page < this.totalPages" @click="moreReply()">显示更多</a> -->
          </div>

          <div class="response" v-if="status != '已解决' && status != '' && status != 'Resolved' && status != 'Closed'&& status != '已关闭'">
            <div class="textarea-box"> <textarea v-model="textareaValue" @dragleave="handleDragLeave"
                @dragover="handleDragOver" @drop="handleDrop" :placeholder="$t('m.ticketdetail.relpy')"></textarea></div>

            <p class="emply-alert" v-if="this.emplyAlert"><svg data-v-cc53d074="" data-v-700d1935="" version="1.1"
                id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 22 22" xml:space="preserve"
                style="width: 14px; fill-rule: evenodd; clip-rule: evenodd; fill: rgb(244, 109, 91);margin:2px 4px -2px 0">
                <g data-v-cc53d074="" data-v-700d1935="">
                  <path data-v-cc53d074="" data-v-700d1935="" d="M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0z M11,19.1c-4.5,0-8.1-3.6-8.1-8.1
		S6.5,2.9,11,2.9s8.1,3.6,8.1,8.1S15.5,19.1,11,19.1z" class="st0"></path>
                  <path data-v-cc53d074="" data-v-700d1935=""
                    d="M11,12.3c0.9,0,1.6-0.7,1.6-1.6V6.1c0-0.9-0.7-1.6-1.6-1.6S9.4,5.2,9.4,6.1v4.6C9.4,11.6,10.1,12.3,11,12.3z"
                    class="st0"></path>
                  <circle data-v-cc53d074="" data-v-700d1935="" cx="11" cy="15.2" r="1.9" class="st0"></circle>
                </g>
              </svg>{{ $t('m.ticketdetail.emply') }}</p>
            <div class="input-box" :class="{ 'drag-over': isDragOver }" @dragleave="handleDragLeave" @click="choiceFile()"
              @dragover="handleDragOver" @drop="handleDrop">
              <input style="display:none" type="file" id="file" ref="file" name="myfile" @change="attachment($event)" />
              <span class="drop win"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="26px" height="22px">
                  <path fill-rule="evenodd" stroke="rgb(1, 1, 1)" stroke-width="0px" stroke-linecap="butt"
                    stroke-linejoin="miter" opacity="0.4" fill="rgb(56, 59, 66)"
                    d="M25.314,16.920 L24.621,20.725 C24.464,21.360 23.769,21.880 23.076,21.880 L12.999,21.880 L2.924,21.880 C2.231,21.880 1.535,21.360 1.378,20.725 L0.684,16.920 C0.527,16.285 0.829,15.522 1.212,14.987 L5.110,10.361 L5.112,10.361 L5.187,10.310 C5.189,10.310 5.190,10.308 5.190,10.308 C5.334,10.220 5.505,10.170 5.685,10.170 L6.870,10.170 C7.052,10.170 7.217,10.246 7.332,10.369 L7.373,10.416 L7.709,10.844 L7.730,10.867 C7.775,10.922 7.803,10.995 7.803,11.071 C7.803,11.243 7.666,11.385 7.493,11.390 L7.472,11.390 L6.762,11.390 L6.762,11.391 C6.554,11.391 6.368,11.491 6.252,11.646 C6.251,11.646 6.250,11.647 6.250,11.647 C6.236,11.667 6.222,11.689 6.210,11.710 C6.208,11.712 6.208,11.712 6.208,11.714 C5.638,12.576 3.994,14.873 3.931,14.987 C3.853,15.126 3.774,15.339 3.803,15.454 C3.846,15.618 3.996,15.692 4.164,15.704 C4.171,15.706 4.178,15.706 4.185,15.706 C4.193,15.706 4.200,15.706 4.208,15.704 L7.130,15.704 L7.327,15.704 C7.873,15.741 8.337,16.083 8.546,16.560 L8.610,16.734 L9.070,18.450 C9.072,18.455 9.074,18.461 9.076,18.467 C9.211,18.823 9.549,19.079 9.949,19.087 C9.957,19.089 9.965,19.089 9.974,19.089 C9.982,19.089 9.990,19.089 9.998,19.087 L12.999,19.087 L16.000,19.087 C16.009,19.089 16.017,19.089 16.026,19.089 C16.034,19.089 16.042,19.089 16.050,19.087 C16.449,19.079 16.788,18.823 16.923,18.467 C16.925,18.461 16.927,18.455 16.929,18.450 L17.389,16.734 L17.453,16.560 C17.663,16.083 18.127,15.741 18.671,15.704 L18.868,15.704 L21.791,15.704 C21.799,15.706 21.805,15.706 21.813,15.706 C21.821,15.706 21.828,15.706 21.836,15.704 C22.004,15.692 22.154,15.618 22.197,15.454 C22.226,15.339 22.147,15.126 22.069,14.987 C22.005,14.871 20.312,12.502 19.765,11.673 C19.650,11.503 19.456,11.391 19.235,11.391 L19.235,11.390 L18.527,11.390 L18.505,11.390 C18.334,11.385 18.197,11.243 18.197,11.071 C18.197,10.995 18.223,10.922 18.269,10.867 L18.290,10.844 L18.626,10.416 L18.666,10.369 C18.782,10.246 18.947,10.170 19.130,10.170 L20.314,10.170 C20.495,10.170 20.665,10.220 20.809,10.308 C20.810,10.308 20.811,10.310 20.811,10.310 L20.888,10.361 L20.889,10.361 L24.786,14.987 C25.170,15.522 25.472,16.285 25.314,16.920 ZM18.414,8.322 L18.414,8.324 L16.499,8.324 L16.392,8.324 C15.933,8.350 15.562,8.705 15.512,9.159 L15.512,9.372 L15.512,13.917 L15.512,14.171 C15.450,14.631 15.056,14.987 14.580,14.987 L11.425,14.987 C10.941,14.987 10.543,14.621 10.490,14.150 L10.490,13.939 L10.490,9.282 C10.490,9.276 10.490,9.270 10.490,9.265 C10.490,9.259 10.490,9.253 10.490,9.249 C10.482,8.754 10.093,8.351 9.604,8.324 L9.496,8.324 L7.586,8.324 L7.586,8.322 C7.240,8.322 6.959,8.041 6.959,7.695 C6.959,7.568 6.997,7.448 7.062,7.351 L7.147,7.247 L12.275,1.022 C12.447,0.813 12.708,0.680 13.001,0.680 C13.293,0.680 13.554,0.813 13.727,1.022 L18.860,7.253 L18.931,7.339 C19.000,7.440 19.041,7.564 19.041,7.695 C19.041,8.041 18.760,8.322 18.414,8.322 Z" />
                </svg>{{ $t('m.ticketdetail.drop') }} <a style="color:#ffc000">{{ $t('m.ticketdetail.dropa') }}</a></span>
              <span class="drop moblie"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="26px" height="22px">
                  <path fill-rule="evenodd" stroke="rgb(1, 1, 1)" stroke-width="0px" stroke-linecap="butt"
                    stroke-linejoin="miter" opacity="0.4" fill="rgb(56, 59, 66)"
                    d="M25.314,16.920 L24.621,20.725 C24.464,21.360 23.769,21.880 23.076,21.880 L12.999,21.880 L2.924,21.880 C2.231,21.880 1.535,21.360 1.378,20.725 L0.684,16.920 C0.527,16.285 0.829,15.522 1.212,14.987 L5.110,10.361 L5.112,10.361 L5.187,10.310 C5.189,10.310 5.190,10.308 5.190,10.308 C5.334,10.220 5.505,10.170 5.685,10.170 L6.870,10.170 C7.052,10.170 7.217,10.246 7.332,10.369 L7.373,10.416 L7.709,10.844 L7.730,10.867 C7.775,10.922 7.803,10.995 7.803,11.071 C7.803,11.243 7.666,11.385 7.493,11.390 L7.472,11.390 L6.762,11.390 L6.762,11.391 C6.554,11.391 6.368,11.491 6.252,11.646 C6.251,11.646 6.250,11.647 6.250,11.647 C6.236,11.667 6.222,11.689 6.210,11.710 C6.208,11.712 6.208,11.712 6.208,11.714 C5.638,12.576 3.994,14.873 3.931,14.987 C3.853,15.126 3.774,15.339 3.803,15.454 C3.846,15.618 3.996,15.692 4.164,15.704 C4.171,15.706 4.178,15.706 4.185,15.706 C4.193,15.706 4.200,15.706 4.208,15.704 L7.130,15.704 L7.327,15.704 C7.873,15.741 8.337,16.083 8.546,16.560 L8.610,16.734 L9.070,18.450 C9.072,18.455 9.074,18.461 9.076,18.467 C9.211,18.823 9.549,19.079 9.949,19.087 C9.957,19.089 9.965,19.089 9.974,19.089 C9.982,19.089 9.990,19.089 9.998,19.087 L12.999,19.087 L16.000,19.087 C16.009,19.089 16.017,19.089 16.026,19.089 C16.034,19.089 16.042,19.089 16.050,19.087 C16.449,19.079 16.788,18.823 16.923,18.467 C16.925,18.461 16.927,18.455 16.929,18.450 L17.389,16.734 L17.453,16.560 C17.663,16.083 18.127,15.741 18.671,15.704 L18.868,15.704 L21.791,15.704 C21.799,15.706 21.805,15.706 21.813,15.706 C21.821,15.706 21.828,15.706 21.836,15.704 C22.004,15.692 22.154,15.618 22.197,15.454 C22.226,15.339 22.147,15.126 22.069,14.987 C22.005,14.871 20.312,12.502 19.765,11.673 C19.650,11.503 19.456,11.391 19.235,11.391 L19.235,11.390 L18.527,11.390 L18.505,11.390 C18.334,11.385 18.197,11.243 18.197,11.071 C18.197,10.995 18.223,10.922 18.269,10.867 L18.290,10.844 L18.626,10.416 L18.666,10.369 C18.782,10.246 18.947,10.170 19.130,10.170 L20.314,10.170 C20.495,10.170 20.665,10.220 20.809,10.308 C20.810,10.308 20.811,10.310 20.811,10.310 L20.888,10.361 L20.889,10.361 L24.786,14.987 C25.170,15.522 25.472,16.285 25.314,16.920 ZM18.414,8.322 L18.414,8.324 L16.499,8.324 L16.392,8.324 C15.933,8.350 15.562,8.705 15.512,9.159 L15.512,9.372 L15.512,13.917 L15.512,14.171 C15.450,14.631 15.056,14.987 14.580,14.987 L11.425,14.987 C10.941,14.987 10.543,14.621 10.490,14.150 L10.490,13.939 L10.490,9.282 C10.490,9.276 10.490,9.270 10.490,9.265 C10.490,9.259 10.490,9.253 10.490,9.249 C10.482,8.754 10.093,8.351 9.604,8.324 L9.496,8.324 L7.586,8.324 L7.586,8.322 C7.240,8.322 6.959,8.041 6.959,7.695 C6.959,7.568 6.997,7.448 7.062,7.351 L7.147,7.247 L12.275,1.022 C12.447,0.813 12.708,0.680 13.001,0.680 C13.293,0.680 13.554,0.813 13.727,1.022 L18.860,7.253 L18.931,7.339 C19.000,7.440 19.041,7.564 19.041,7.695 C19.041,8.041 18.760,8.322 18.414,8.322 Z" />
                </svg>
                {{ $t('m.ticketdetail.dropShort') }}

              </span>
            </div>
            <!-- <div class="alert black " :class="{ big: this.$i18n.locale == 'zh' }">
              {{ $t("m.ticket.limit") }}
            </div> -->
            <transition-group name="fade">
              <div class="update" v-for=" item, index  in  rep.attachments " :key="item.name">
                <div @click="openAtt(item.url)" class="single-line-ellipsis">
                  <svg class="link" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="20px" height="21px">
                    <path fill-rule="evenodd" stroke="rgb(137, 137, 137)" stroke-width="2px" stroke-linecap="round"
                      stroke-linejoin="miter" fill="none"
                      d="M9.645,7.988 C9.056,8.608 5.398,12.385 4.772,13.044 C4.319,13.520 4.348,14.359 4.796,14.830 C5.244,15.301 6.034,15.325 6.487,14.849 C6.864,14.452 14.363,6.557 14.245,6.682 C15.142,5.737 15.091,4.078 14.195,3.136 C13.300,2.194 11.712,2.126 10.815,3.071 C9.572,4.379 4.246,9.987 3.077,11.217 C1.890,12.467 1.645,15.156 3.070,16.655 C4.495,18.155 6.808,18.152 8.236,16.649 C9.665,15.145 16.099,8.446 16.099,8.446 " />
                  </svg>
                  {{ item.name }}
                </div>
                <svg class="close" v-if="!item.url" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" style="display:block;margin:0 -5px 0 0;" width="22px"
                  height="22px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                  <circle cx="50" cy="50" fill="none" stroke="#ffbf5a" stroke-width="14" r="27"
                    stroke-dasharray="127.23450247038662 44.411500823462205">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite"
                      dur="1.7543859649122806s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                  </circle>
                </svg>
                <svg class="close" v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="12px" height="12px" @click="closeAttachment(index)">
                  <path fill-rule="evenodd" stroke="rgb(137, 137, 137)" stroke-width="2px" stroke-linecap="round"
                    stroke-linejoin="miter" fill="none" d="M9.000,2.000 L2.000,8.999 " />
                  <path fill-rule="evenodd" stroke="rgb(137, 137, 137)" stroke-width="2px" stroke-linecap="round"
                    stroke-linejoin="miter" fill="none" d="M2.000,2.000 L9.000,8.999 " />
                </svg>
              </div>

            </transition-group>
            <div class="sub-box">
              <!-- <Btn :text="$t('m.ticketdetail.sub')" :route="''" @click="submit()"></Btn> -->
              <div class="sub" @click="reply()">
                {{ $t("m.ticketdetail.sub") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loading v-else :bgColor="''"></Loading>
    </div>
    <!-- <Featured></Featured> -->
    <AlertSideBar ref="AlertSideBar"></AlertSideBar>
  </div>
</template>
<script>
import moment from 'moment-timezone';
import Loading from "../components/Loading.vue";
import AlertSideBar from "../components/AlertSideBar.vue";
import BannerSearch from "../components/BannerSearch.vue";
// import Featured from "../components/Featured.vue";
import Btn from "../components/Btn.vue";

import i18n from "../lang";
export default {
  components: { BannerSearch, Btn, AlertSideBar, Loading },
  inject: ["reload"],
  data() {
    return {
      sideInnerHtml: "",
      detail: "",
      resp: [],
      stop: true,
      textareaValue: "",
      ticket: [],
      atts: [],
      title: "",
      emplyAlert: false,
      status: '',
      totalPages: "",
      page: 1,
      replies: "",
      isDragOver: false,
      rep: {
        attachments: [

        ],
      },
      attachment_ids: [],
      lang: i18n.locale,
      userTimeZone: "",
    };
  },
  mounted() {
    this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    console.log(this.userTimeZone);

    if (localStorage.getItem('result_code') == '') {

      this.$store.commit("Logout");
      this.$router.push('/login')
    }
    if (this.$udesk && this.$store.state.TicketFieldsLang.length != 0 && this.$udesk.getDataReady) {
      console.log("123333");

      this.$udesk.sdk
        .request()
        .getTicketDetail(this.$route.params.id)
        .then((res) => {
          console.log(res);

          this.status = res.ticket.detail_fields.status;
          if (res.ticket.detail_fields.status == '开启') {
            res.ticket.detail_fields.status = '待解决'
          }
          if (res.ticket.detail_fields.status == 'Open') {
            res.ticket.detail_fields.status = 'Unresolved'
          }
          if (res.ticket.detail_fields.status == 'Solving') {
            res.ticket.detail_fields.status = 'In progress'
          }
          if (this.$i18n.locale == 'zh') {
            this.title = res.ticket.detail_other_fields.TextField_1371
            this.detail = res.ticket.detail_other_fields.content;
            delete res.ticket.detail_fields.TextField_2251;
          } else {
            this.title = res.ticket.detail_other_fields.TextField_2078
            this.detail = res.ticket.detail_other_fields.TextField_2079;
            delete res.ticket.detail_fields.TextField_2250;
          }


          this.atts = res.ticket.detail_other_fields.attachments
          console.log(this.$store.state.ticketPlugin);
          this.$store.state.ticketPlugin.map(item => {
            if (this.$i18n.locale == 'zh') {
              for (const field in this.$store.state.TicketFieldsLang) {
                // 去掉bind修改
                if (field != 'TextField_2251' && field == item) {

                  let v1 = res.ticket.detail_fields[item];
                  let v2 = this.$store.state.TicketFieldsLang[field];
                  let obj = { field_name: v2, field_detail: v1 };
                  this.ticket.push(obj);
                }
              }
            } else {
              for (const field in this.$store.state.TicketFieldsLang) {
                if (field != 'TextField_2250' && field == item) {

                  let v1 = res.ticket.detail_fields[item];
                  let v2 = this.$store.state.TicketFieldsLang[field];
                  let obj = { field_name: v2, field_detail: v1 };
                  this.ticket.push(obj);
                }
              }
            }

          })

          console.log(this.ticket);
        });
      this.$udesk.sdk
        .request()
        .getTicketReplies(this.$route.params.id)
        .then((res) => {
          console.log(res);


          this.replies = res.replies;

          this.totalPages = res.meta.total_pages
          if (res.meta.total_pages > 1) {
            for (let index = 2; index < res.meta.total_pages; index++) {
              this.moreReply(index)
              console.log(index);
            }
          }
          console.log(this.replies);
          this.replies.reverse()

        });

    }

  },
  methods: {
    formatTime(time) {
      const beijingTime = new Date(time);
      const year = beijingTime.getFullYear();
      const month = beijingTime.getMonth() + 1;
      const day = beijingTime.getDate();
      const hours = beijingTime.getHours();
      const minutes = beijingTime.getMinutes();
      const seconds = beijingTime.getSeconds();
      const formattedTime = `${year}-${this.padZero(month)}-${this.padZero(day)}T${this.padZero(hours)}:${this.padZero(
        minutes
      )}:${this.padZero(seconds)}.000+08:00`;

      const converted = moment(formattedTime).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
      console.log(converted.format('YYYY-MM-DD HH:mm:ss'));
      return converted.format('YYYY-MM-DD HH:mm:ss');
    },
    padZero(number) {
      return number.toString().padStart(2, "0");
    },

    convertedTime(time) {
      console.log(time);
      // 将原始时间转换为用户所在时区的时间
      const converted = moment(time).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
      console.log(converted.format('YYYY-MM-DD HH:mm:ss'));
      return converted.format('YYYY-MM-DD HH:mm:ss');

    },
    timeChange(date) {

      return date.split('T')[0] + ' ' + date.split('T')[1].split('.')[0]
    },
    moreReply(page) {
      this.$udesk.sdk
        .request()
        .getTicketReplies(this.$route.params.id, { 'page': page })
        .then((res) => {
          res.replies.map(item => {
            console.log(item);
            this.replies.push(item)
          })
          console.log(this.replies);
        });
    },
    checkSelect(li, value) {
      console.log(li, value);
      let num = value.split(',')
      var res = ''
      res = res + '/' + li.select_options[num[0]].title
      var mapData = li.select_options[num[0]].subs
      if (num.length > 1) {
        for (let index = 1; index < num.length; index++) {
          mapData.map((item, index) => {
            if (index == num[0]) {
              mapData = item
              res = res + '/' + item.title
            }
          })
        }
      }
      return res.replace("/", "")
    },
    openAtt(url) {
      window.open(url)
    },
    closeAttachment(index) {
      this.rep.attachments.splice(index, 1)
      this.attachment_ids.splice(index, 1)
    },

    handleDragOver(event) {
      event.preventDefault(); // 阻止默认行为
      this.isDragOver = true;

    },
    handleDragLeave(event) {
      event.preventDefault(); // 阻止默认行为
      this.isDragOver = false;

    },
    handleDrop(event) {
      event.preventDefault();
      const files = Array.from(event.dataTransfer.files);
      this.isDragOver = false;
      files.map(file => {
        this.rep.attachments.push({
          name: file.name,
          url: '',
        })
        this.$udesk.sdk
          .request().uploadAttachment(file).then((res) => {
            console.log(res);
            this.attachment_ids.push(res.attachment_id)
            this.rep.attachments.map(item => {
              if (item.name == file.name) {
                item.url = res.src
              }
            })
          })
      })
      // 在这里执行上传文件的操作
      console.log('拖拽上传文件:', file);


    },
    choiceFile() {
      this.$refs.file.dispatchEvent(new MouseEvent('click'))
    },
    attachment(e) {
      const file = e.target.files[0];
      console.log(e.target.files[0]);

      this.rep.attachments.push({
        name: file.name,
        url: '',
      })
      this.$udesk.sdk
        .request().uploadAttachment(file).then((res) => {
          console.log(res);
          this.attachment_ids.push(res.attachment_id)
          this.rep.attachments.map(item => {
            if (item.name == file.name) {
              item.url = res.src
            }
          })
        })

    },
    reply() {
      if (this.textareaValue.trim() == '') {
        this.emplyAlert = true
      } else {
        console.log(this.attachment_ids);
        if (this.$udesk) {
          this.$udesk.sdk
            .request()
            .postTicketReplies(this.$route.params.id, {
              reply: {
                attachment_ids: this.attachment_ids,
                content: this.textareaValue,
                content_type: "text",
              },
            })
            .then((res) => {
              console.log(this.reload());
              this.textareaValue = ''
              this.rep.attachments = []
              this.attachment_ids = []
              this.$udesk.sdk
                .request()
                .getTicketReplies(this.$route.params.id)
                .then((res) => {
                  this.emplyAlert = false
                  this.replies = res.replies;
                  this.totalPages = res.meta.total_pages
                  if (res.meta.total_pages > 1) {
                    for (let index = 2; index < res.meta.total_pages; index++) {
                      this.moreReply(index)
                      console.log(index);
                    }
                  }
                  console.log(res);
                  this.replies.reverse()
                });

            });
        }
      }

    },
    onChange(file, fileLis) {
      console.log(file, fileLis);
      if (file.status == "ready") {
        this.$udesk.sdk.request().fetchAttachmentApi({
          attachment: {
            qiniu_key: file.url,
            file_file_name: file.name,
            file_content_type: file.type,
            file_file_size: file.size,
            bucket,
            storage_policy,
          },
        });
      }
    },

    downloadImg(url) {
      window.open(url);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/ticketdetail.scss";
</style>